import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { Router } from '@angular/router';
import { CONSTANTS } from 'src/app/constants';
import { ModalPersonStatisticsComponent } from '../modal-person-statistics/modal-person-statistics.component';

@Component({
  selector: 'app-condition-pending',
  templateUrl: './condition-pending.component.html',
  styleUrls: ['./condition-pending.component.css']
})
export class ConditionPendingComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @ViewChild('modalStats', { static: false }) modalStats!: ModalPersonStatisticsComponent;
  @Output() errorEmitter = new EventEmitter();

  personStatisticsInfo: any = 0;
  limitPersonInfo: number = 0;
  openInvoiceValue: number = 0;
  personSelect: any = {};
  filterInicial: any = {}
  branchCodes: any[] = [];
  tableItens: any[] = [];
  tableItensOriginal: any[] = [];
  ordem: boolean = true;
  loading: boolean = false;
  filterChange: any;
  errorApi: boolean = false;
  message: string = "";

  constructor(private api: ApiService, private router: Router) { }

  ngOnInit(): void {
  }

  filterItem(item: any) {
    this.tableItens = [];
    this.loading = true;
    this.filterChange = item;
    this.filterInicial = item;
    if (item.branch != undefined) {
      let excelInfo: any[] = [];
      this.pendingConditionalsReturn(item).subscribe((data: any) => {
        data.dataRow.map((el:any) => {
          this.tableItens.push({
            "personCode": el.personCode,
            "cliente": el.personName,
            "quantidade": el.productQuantity,
            "qtdDias": el.quantityDays,
            "valor": parseFloat(el.productValue).toLocaleString('pt-BR', {minimumFractionDigits: 2 , style: 'currency', currency: 'BRL'}),
            "valorOriginal": el.productValue
          })
          this.tableItensOriginal = this.tableItens;
          excelInfo.push({
            'Data Inicial': item.dataMin,
            'Data Final': item.dataMax,
            'Cliente': el.personName,
            'Quantidade': el.productList.length.toString(),
            'Quantidade Dias': el.quantityDays.toString(),
            'Valor': parseFloat(el.productValue).toLocaleString('pt-BR', {minimumFractionDigits: 2 , style: 'currency', currency: 'BRL'})});
        });
        excelInfo.unshift({});
        localStorage.setItem('condition-pending-sellers', JSON.stringify(excelInfo));
        this.loading = false;
        this.errorApi = false;
      },
      (error) => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_CONDITION_PENDING;
        this.formatErrorMensagem(error.message);
      });
    }
  }

  openChart(item: any) {
    this.personSelect = item;
    const filterInfoBranchs = localStorage.getItem("filterInfoBranchs");
    this.branchCodes = filterInfoBranchs ? JSON.parse(filterInfoBranchs) : this.filterInicial.branch;
    this.modalStats.open(item, this.branchCodes);
  }

  personStatisticsReturn(item: any) {
    const filterInfoBranchs = localStorage.getItem("filterInfoBranchs");
    const parsedBranches = filterInfoBranchs ? JSON.parse(filterInfoBranchs) : this.filterInicial.branch;

    return this.api.getPersonStatistics(item.personCode, parsedBranches);
  }

  limitsPersonReturn(item: any) {
    const filterInfoBranchs = localStorage.getItem("filterInfoBranchs");
    const parsedBranches = filterInfoBranchs ? JSON.parse(filterInfoBranchs) : this.filterInicial.branch;

    return this.api.postCustomerFinancialBalance(item.personCode, parsedBranches);
  }

  ordenarTabela(colunaTipo: any) {
    this.loading = true;
    if (colunaTipo === 'cliente') {
      this.tableItens = this.tableItensOriginal;
      this.tableItens.sort((a: any, b: any) => {
        return this.ordem
        ? a.cliente[0].toLowerCase().localeCompare(b.cliente[0].toLowerCase())
        : b.cliente[0].toLowerCase().localeCompare(a.cliente[0].toLowerCase());
      });

      const iconCliente = document.getElementById('icon-cliente-condition-pending');
      this.ordem
      ? (
          iconCliente!.classList.remove('po-icon', 'po-icon-arrow-down'),
          iconCliente!.classList.add('po-icon', 'po-icon-arrow-up')
        )
      : (
          iconCliente!.classList.remove('po-icon', 'po-icon-arrow-up'),
          iconCliente!.classList.add('po-icon', 'po-icon-arrow-down')
        )

      this.ordem = !this.ordem;
      this.loading = false;
    }
    if (colunaTipo === 'qtd') {
      this.tableItens.sort((a: any, b: any): any => {
        const valueA = parseFloat(a.quantidade);
        const valueB = parseFloat(b.quantidade);
        return this.ordem ? valueA - valueB : valueB - valueA;
      });

      const iconCliente = document.getElementById('icon-qtd-condition-pending');
      this.ordem
      ? (
          iconCliente!.classList.remove('po-icon', 'po-icon-arrow-down'),
          iconCliente!.classList.add('po-icon', 'po-icon-arrow-up')
        )
      : (
          iconCliente!.classList.remove('po-icon', 'po-icon-arrow-up'),
          iconCliente!.classList.add('po-icon', 'po-icon-arrow-down')
        )

      this.ordem = !this.ordem;
      this.loading = false;
    }
    if (colunaTipo === 'qtd-dias') {
      this.tableItens.sort((a: any, b: any): any => {
        const valueA = parseFloat(a.qtdDias);
        const valueB = parseFloat(b.qtdDias);
        return this.ordem ? valueA - valueB : valueB - valueA;
      });

      const iconCliente = document.getElementById('icon-qtd-dias-condition-pending');
      this.ordem
      ? (
          iconCliente!.classList.remove('po-icon', 'po-icon-arrow-down'),
          iconCliente!.classList.add('po-icon', 'po-icon-arrow-up')
        )
      : (
          iconCliente!.classList.remove('po-icon', 'po-icon-arrow-up'),
          iconCliente!.classList.add('po-icon', 'po-icon-arrow-down')
        )

      this.ordem = !this.ordem;
      this.loading = false;
    }
    if (colunaTipo === 'valor') {
      this.tableItens.sort((a: any, b: any): any => {
        const valueA = parseFloat(a.valorOriginal);
        const valueB = parseFloat(b.valorOriginal);
        return this.ordem ? valueA - valueB : valueB - valueA;
      });

      const iconCliente = document.getElementById('icon-valor-condition-pending');
      this.ordem
      ? (
          iconCliente!.classList.remove('po-icon', 'po-icon-arrow-down'),
          iconCliente!.classList.add('po-icon', 'po-icon-arrow-up')
        )
      : (
          iconCliente!.classList.remove('po-icon', 'po-icon-arrow-up'),
          iconCliente!.classList.add('po-icon', 'po-icon-arrow-down')
        )

      this.ordem = !this.ordem;
      this.loading = false;
    }
  }

  pendingConditionalsReturn(item: any) {
    return this.api.postPendingConditionalsSellerPanel(item.branch);
  }

  goToPeddingConditionals() {
    localStorage.setItem('filterInfoBranchs', JSON.stringify(this.filterChange.branch));
    localStorage.setItem('filterInfoMinDate', JSON.stringify(this.filterChange.dataMin));
    localStorage.setItem('filterInfoMaxDate', JSON.stringify(this.filterChange.dataMax));
    this.router.navigate(['/pedding-conditionals'],
      { queryParams: { 'branch': this.filterChange.branch } }
    );
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataConditionPending = [];
    let objectConditionPending = localStorage.getItem('condition-pending-sellers');

    objectConditionPending != null
      ? (dataConditionPending = JSON.parse(objectConditionPending))
      : (dataConditionPending = []);
    const worksheetConditionPending= XLSX.utils.json_to_sheet(dataConditionPending);

    const workbook = {
      Sheets: {
        'condition-pending': worksheetConditionPending,
      },
      SheetNames: [
        'condition-pending',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-condition-pending' + EXCEL_EXTENSION);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: condition-pending \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
